var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"expand-row"},[_c('Col',{attrs:{"span":"24"}},[_c('span',{staticClass:"expand-key"},[_vm._v(_vm._s(_vm.title)+":")])]),_c('Col',{attrs:{"span":"24"}},[_c('span',{staticClass:"expand-value"},[_c('h4',[_vm._v(_vm._s(_vm.row.message))]),_c('pre',[_vm._v(_vm._s(_vm.row.stacktrace))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }